import React, { useState, useContext, useEffect, useRef } from "react";

import { ReactComponent as SORT } from "../../assets/icons/sort.svg";
import { ReactComponent as DELETE } from "../../assets/icons/delete.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";

import { NotificationContext } from "../../Context/NotificationContext";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import TeamTitleWithSearch from "../../Components/ui/TeamTitleWithSearch";
import NoData from "../../NewComponents/NoData";
import EditTeamPopUp from "../../NewComponents/EditTeamPopUp";
import AddTeamMemberPopUp from "../../NewComponents/AddTeamMemberPopUp";
import CreateTeamPopUp from "../../NewComponents/CreateTeamPopUp";

import "./Teams.css";
import { firestore } from "../../firebase.config";
import PopUpModal from "../../NewComponents/PopUpModal";
import { DataContext } from "../../Context/DataContext";
import { AuthContext } from "../../Context/AuthContext";

const Teams = ({ windowSize }) => {
  const { signedIn } = useContext(AuthContext);
  const { userData } = useContext(DataContext);
  const { showNotification } = useContext(NotificationContext);
  const [filterSearch, setFilterSearch] = useState("");
  const { transitionTo } = useScreenTransition();
  const [moreOptions, setMoreOptions] = useState("");
  const [teamsData, setTeamsData] = useState([]);
  const [membersData, setMembersData] = useState([]);

  const [showDetailModal, setShowDetailModal] = useState("");
  const [selectedSort, setSelectedSort] = useState("name");
  const [filteredTeams, setFilteredTeams] = useState([]);
  const [deleteTeamPopUp, setDeleteTeamPopUp] = useState(false);
  const [editTeamPopUp, setEditTeamPopUp] = useState(false);
  const [addMemberPopUpOpen, setAddMemberPopUpOpen] = useState(false);
  const [createTeamPopUpOpen, setCreateTeamPopUpOpen] = useState(false);
  const [currentTeam, setCurrentTeam] = useState();
  const [deleteTeamBtn, setDeleteTeamBtn] = useState("Delete Team");
  const [loading, setLoading] = useState(true);

  let firstLoad = useRef();
  if (!firstLoad.current) firstLoad.current = true;

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;

  useEffect(() => {
      if(!signedIn || (userData && userData.role === "client")){
        return transitionTo("/");
      }
    }, [signedIn, userData]);

  const checkAnyFilterSelected = () => {
    if (filterSearch !== "") {
      return true;
    } else {
    }

    return false;
  };

  useEffect(() => {
    let query = firestore.collection("teams");

    const unsubscribe = query.onSnapshot(async (snapshot) => {
      setLoading(true);
      try {
        const teamsData = await Promise.all(
          snapshot.docs.map(async (teamDoc) => {
            return { id: teamDoc.id, ...teamDoc.data() };
          })
        );
  
        setTeamsData(teamsData);
        setLoading(false);

      } catch (error) {
        setLoading(false);
        console.error("Error fetching teams: ", error);
        showNotification("Error", "Failed to fetch team data", "error");
      }
    });
  
    return () => unsubscribe();
  }, [userData]); 



  useEffect(() => {
    const unsubscribe = firestore.collection("users").onSnapshot(async (snapshot) => {
      setLoading(true);
      try {
        const membersData = 
          snapshot.docs.map( (memberDoc) => {
            return { id: memberDoc.id, ...memberDoc.data() };
          })
        setMembersData(membersData.filter((user) => user.teamId));
        setLoading(false);

      } catch (error) {
        setLoading(false);
        console.error("Error fetching members: ", error);
        showNotification("Error", "Failed to fetch member data", "error");
      }
    });

    return () => unsubscribe();
  } ,[teamsData, userData]);
    

  const sortData = (data) => {
    const sortedData = data.sort((a,b) => {
      if(selectedSort === "timestamp" || selectedSort === "discount"){
        return b[selectedSort] - a[selectedSort];
      }

      if(selectedSort === "members"){
        return getTeamMembers(b.id).length - getTeamMembers(a.id).length;
      }

      return a[selectedSort].toLowerCase() > b[selectedSort].toLowerCase() ? 1 : -1;
    });

    return sortedData;
  }

  useEffect(() => {
    let filterdData = teamsData;
    if (filterSearch) {
      filterdData = filterdData.filter((item) => {
        return item.name.toLowerCase().includes(filterSearch.toLowerCase());
      });
    }

    setFilteredTeams(filterdData);
  }, [teamsData, filterSearch, membersData])

  const getTeamMembers = (teamId) => {
    if(membersData.length === 0) return [];
    return membersData.filter((member) => member.teamId === teamId);
  };

  const handleOpenAddMemberPopUp = () => {
    setAddMemberPopUpOpen(true);
  };
  const handleOpenCreateTeamPopUp = () => {
    setCreateTeamPopUpOpen(true);
  };

  const handleCloseAddMemberPopUp = () => {
    setCurrentTeam(null);
    setAddMemberPopUpOpen(false);
  };
  const handleCloseEditTeamPopUp = () => {
    setCurrentTeam(null);
    setEditTeamPopUp(false);
  };

  const handleCloseCreateTeamPopUp = () => {
    setCreateTeamPopUpOpen(false);
  };
  const handleCloseDeleteTeamPopUp = () => {
    setCurrentTeam(null);
    setDeleteTeamPopUp(false);
  };
  const btnAddMember = (team) => {
    setCurrentTeam(team);
    setAddMemberPopUpOpen(true);
  };
  const btnEditTeam = (team) => {
    setCurrentTeam(team);
    setEditTeamPopUp(true);
  };
  const btnDeleteTeam = (team) => {
    setCurrentTeam(team);
    setDeleteTeamPopUp(true);
  };
  const formatDate = (timestamp) => {
    if (!timestamp) return null;

    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    return splitted[1] + " " + splitted[2] + ", " + splitted[3];
  };

  const handleDeleteTeam = async () => {
    setDeleteTeamBtn("Deleting...");
    try{
      await firestore.collection("teams").doc(currentTeam.id).delete().then(() => {
        setCurrentTeam(null);
        setDeleteTeamPopUp(false);
      });
    }catch (error) {
      console.error("Error deleting team: ", error);
      showNotification("Error", "Failed to delete team", "error");
    }finally{
      setDeleteTeamBtn("Delete Team");
    }
  }

  return (
    <>
      <AccountNavBar
        windowSize={windowSize}
        selectedTab="teams"
        accountMainPadding={false}
        admin={true}
        showButton={true}
      >
        <TeamTitleWithSearch
          title="Teams"
          placeholder="Search by Team Name"
          onAddMemberClick={handleOpenAddMemberPopUp}
          showCreateBtn={true}
          onCreateTeamClick={handleOpenCreateTeamPopUp}
          onSearch={(val) => setFilterSearch(val)}
        />

        {createTeamPopUpOpen && (
          <CreateTeamPopUp
          onClose={handleCloseCreateTeamPopUp}
          />
        )}

        {addMemberPopUpOpen && (
          <AddTeamMemberPopUp
            existingTeams={teamsData}
            currentTeam={currentTeam}
            onClose={handleCloseAddMemberPopUp}
          />
        )}

        {editTeamPopUp && currentTeam && (
          <EditTeamPopUp
            currentTeam={currentTeam}
            onClose={handleCloseEditTeamPopUp}
          />
        )}

        {deleteTeamPopUp && currentTeam && (

          <PopUpModal
          title={"Delete Team"}
          backBtnText="Cancel"
          subText="Are you sure you want to delete the team? All users will lose access to the team and its privileges."
          text={currentTeam.name}
          btnText={deleteTeamBtn}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={handleCloseDeleteTeamPopUp}
          onClick={handleDeleteTeam}
          onBackClick={handleCloseDeleteTeamPopUp}
          disableBtn={deleteTeamBtn === "Deleting..."}
          >
          <DELETE />
          </PopUpModal>
        )}

        {loading ? 
          <NoData type="teams" loading={true} showBtn={false} loadingText={"teams"}/>
          : filteredTeams?.length === 0 && !checkAnyFilterSelected() ? (
          <NoData type="teams" title={"No Team Found."} text="Please create a team" showBtn={false} />
        ) : (
          <div className="accountDetailsScroll w-full">
            <table className="accountDetailsTable">
              <thead>
                <tr>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Team Name</p>
                      {selectedSort === "name" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("name")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("name")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Members</p>
                      {selectedSort === "members" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("members")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("members")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Discount</p>
                      {selectedSort === "discount" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("discount")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("discount")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div className="accountData">
                      <p className="accountDetailsHeading">Expedited</p>
                      {selectedSort === "expeditedServices" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("expeditedService")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("expeditedServices")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div
                      className="accountData"
                      style={{  maxWidth: "170px" }}
                    >
                      <p className="accountDetailsHeading">Creation Date</p>
                      {selectedSort === "timestamp" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("timestamp")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("timestamp")}
                        />
                      )}
                    </div>
                  </th>
                  <th>
                    <div
                      className="accountData"
                      style={{  maxWidth: "170px" }}
                    >
                      <p className="accountDetailsHeading">Free Expdited</p>
                      {/* {selectedSort === "timestamp" ? (
                        <SORT
                          className="sortIcon"
                          onClick={() => setSelectedSort("timestamp")}
                        />
                      ) : (
                        <SORTBLACK
                          className="sortIcon"
                          onClick={() => setSelectedSort("timestamp")}
                        />
                      )} */}
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>
              {filteredTeams.length > 0 && (
                <tbody>
                  {sortData(filteredTeams).map((team, i) => (
                    <tr key={team.id + i}  onClick={(e) =>
                      transitionTo(`/office/team/${team.id}`, e)
                    }>
                      <td
                        onClick={(e) =>
                          transitionTo(`/office/team/${team.id}`, e)
                        }
                      >
                        {team.name &&
                          team.name.length > 15 &&
                          showDetailModal === team.id + team.name && (
                            <div className="accountdetailHoverBox">
                              <p
                                className="accountDetailsText"
                              >
                                {team.name}
                              </p>
                            </div>
                          )}
                        <p
                          className="accountDetailsText"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                            setShowDetailModal(team.id + team.name)
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                        >
                          {team.name || "-"}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText">
                          {getTeamMembers(team.id).length}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText">
                          {team?.discount ? `${team.discount}%` : "-"}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText capitalize">
                          {team.expeditedServices}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText">
                          {formatDate(team.lastInvoiceTimestamp)}
                        </p>
                      </td>
                      <td>
                        <p className="accountDetailsText">
                          {team.freeExpeditedOrders || "-"}
                        </p>
                      </td>
                      {
                        <td>
                          <div
                            className="hardCopyAddressIconWrap"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevents event bubbling
                              setMoreOptions((prev) =>
                                prev === team.id ? "" : team.id
                              );
                            }}
                            tabIndex={0} // Enables blur event for accessibility
                            onBlur={() => setMoreOptions("")}
                          >
                            {moreOptions === team.id ? (
                              <MORESELECTED
                                className="hardCopyAddressIcon"
                              />
                            ) : (
                              <MORE
                                className="hardCopyAddressIcon"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevents event bubbling
                                  setMoreOptions((prev) =>
                                    prev === team.id ? "" : team.id
                                  );
                                }}
                              />
                            )}
                            {moreOptions === team.id && (
                              <div className="hardCopyAddressEditWrap">
                                <div
                                  className="hardCopyAddressEdit"
                                  onClick={() => btnAddMember(team)}
                                >
                                  Add Member
                                </div>
                                <div
                                  className="hardCopyAddressEdit"
                                  onClick={() => btnEditTeam(team)}
                                >
                                  Edit Team
                                </div>
                                <div
                                  className="hardCopyAddressEdit"
                                  onClick={() => btnDeleteTeam(team)}
                                >
                                  Delete Team
                                </div>
                              </div>
                            )}
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              )}
            </table>

          </div>
        )}
      </AccountNavBar>
    </>
  );
};

export default Teams;
